import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint2 } from './parts/sideParts'
import { drawWithImagePattern, drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const hWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ横1(先端)
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ横2
  await middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10, printLeatherTypeValue)
  // ウェブ縦
  const drawVerticalPath = () => {
    ctx.beginPath()
    ctx.moveTo(241, 235) // 左＿上
    ctx.quadraticCurveTo(254, 267, 254, 267) // 左＿下
    ctx.quadraticCurveTo(265, 243, 293, 208) // 右＿下
    ctx.quadraticCurveTo(283, 168, 283, 168) // 右＿上
    ctx.quadraticCurveTo(254, 199, 241, 237) // 左＿上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawVerticalPath, webColor2)

  ctx.fillStyle = webColor

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // Hウェブ縦＿左＿外側
  ctx.moveTo(245, 235) // 上
  ctx.quadraticCurveTo(255, 262, 255, 262) // 下
  // Hウェブ縦＿左＿内側
  ctx.moveTo(247, 231) // 上
  ctx.quadraticCurveTo(257, 259, 257, 259) // 下
  // // Hウェブ縦＿右＿内側
  ctx.moveTo(278, 178) // 上
  ctx.quadraticCurveTo(287, 210, 287, 210) // 下
  // // Hウェブ縦＿右＿外側
  ctx.moveTo(281, 175) // 上
  ctx.quadraticCurveTo(290, 210, 290, 210) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}

export const hJointWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ縦
  const drawVerticalWeb = () => {
    ctx.beginPath()
    ctx.moveTo(266, 245) // 左＿上
    ctx.quadraticCurveTo(273, 275, 273, 275) // 左＿下
    ctx.quadraticCurveTo(319, 218, 319, 218) // 右＿下
    ctx.quadraticCurveTo(312, 173, 312, 173) // 右＿上
    ctx.quadraticCurveTo(264, 200, 266, 245) // 左＿上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const verticalWebColor = webColor2 || webColor
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawVerticalWeb, verticalWebColor)

  ctx.fillStyle = webColor
  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // Hウェブ縦＿左＿外側
  ctx.moveTo(269, 242) // 上
  ctx.quadraticCurveTo(276, 273, 276, 273) // 下
  // // Hウェブ縦＿左＿内側
  ctx.moveTo(270, 238) // 上
  ctx.quadraticCurveTo(277, 270, 277, 270) // 下
  // // // Hウェブ縦＿右＿内側
  ctx.moveTo(307, 185) // 上
  ctx.quadraticCurveTo(313, 220, 313, 222) // 下
  // // // Hウェブ縦＿右＿外側
  ctx.moveTo(309, 180) // 上
  ctx.quadraticCurveTo(316, 219, 316, 219) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ先端
  const drawWebTip = () => {
    ctx.lineWidth = 0.5
    ctx.beginPath()
    ctx.moveTo(242, 277) // 左上
    ctx.quadraticCurveTo(252, 291, 250, 290) // 左下
    ctx.quadraticCurveTo(275, 180, 368, 135) // 右下
    ctx.quadraticCurveTo(356, 122, 356, 122) // 右上
    ctx.quadraticCurveTo(258, 175, 242, 277) // 右上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const webTipColor = webColor2 || webColor
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawWebTip, webTipColor)
  ctx.strokeStyle = '#282828'
  ctx.beginPath()
  ctx.moveTo(250, 290) // 左下
  ctx.quadraticCurveTo(275, 180, 368, 135) // 右下
  ctx.stroke()
  ctx.closePath()

  // ウェブ横1(先端)
  await topSidePartOfWebWithJoint2(ctx, webColor, webColor2, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ横2
  await middleSidePartOfWeb(ctx, webColor, stitchColor, 15, 35, printLeatherTypeValue)
}
